// Máscara de PRESENÇA (checkbox com `presence: true`): mostra um check quando o dado existe e nada quando não existe. O check indica DISPONIBILIDADE do canal, não validação.
// Com `link`, o check abre a ação apropriada: `url` (http/https), `mailto` (e-mail) ou `tel` (telefone). Nunca monta href a partir de valor que não passe na validação.
const HTTP = /^https?:\/\/[^\s]+$/i;
const EMAIL = /^[^\s@<>"']+@[^\s@<>"']+\.[^\s@<>"']+$/;
const PHONE = /^\+?[0-9()\s.-]{6,24}$/;

export const hasPresence = (raw) => String(raw ?? '').trim() !== '';

/** @returns {string|null} href seguro para o tipo de ação, ou null quando o valor não é utilizável. */
export const presenceHref = (link, raw) => {
  const value = String(raw ?? '').trim();
  if (!value) return null;
  if (link === 'url') return HTTP.test(value) ? value : null;
  if (link === 'mailto') return EMAIL.test(value) ? `mailto:${value}` : null;
  if (link === 'tel') return PHONE.test(value) ? `tel:${value.replace(/[^0-9+]/g, '')}` : null;
  return null;
};
